// @flow
import React, { useState, useEffect } from 'react';

import styles from './Articles.module.scss';
import { Link } from 'react-router-dom';
import articleOne from '../../assets/images/articles/articleOne.webp';
import articleTwo from '../../assets/images/articles/articleTwo.webp';
import articleThree from '../../assets/images/articles/articleThree.webp';
import faq from '../../assets/images/articles/faq.jpg';
import trainingFaq from '../../assets/images/articles/trainingfaq.webp';
import routes from '../../constants/routes';

const getLanguage = () => {
  const lang = localStorage.getItem('i18nextLng');
  if (lang?.includes('ru')) return 'ru';
  if (lang?.includes('en')) return 'en';
  return 'en';
};

const Articles = () => {
  const [language, setLanguage] = useState<string>('');
  const [isPlo5, setPlo5] = useState<boolean>(sessionStorage.getItem('isPlo5') === 'true');
  const mapArticles = new Map();
  mapArticles.set('en', [
    'Single suited or double suited? (PLO 4)',
    'Good suited or Bad suited? (PLO 4)',
    'I would go to the omashists, let them teach me',
    'Good Suited or Bad Suited? (PLO 5)',
    'Single Suited or Double Suited? (PLO 5)',
    'FAQ',
    'Preflop Text Guide',
    'Training Text Guide',
  ]);
  mapArticles.set('ru', [
    'Типы рук (PLO 4)',
    'Good suited или Bad suited? (PLO 4)',
    'В омашисты я б пошёл, пусть меня научат',
    'Good Suited или Bad Suited? (PLO 5)',
    'Single Suited или Double Suited? (PLO 5)',
    'FAQ',
    'Preflop Text Guide',
    'Training Text Guide',
  ]);

  useEffect(() => {
    function checkPlo5() {
      const item = sessionStorage.getItem('isPlo5');
      setPlo5(item === 'true');
    }

    window.addEventListener('storage', checkPlo5);

    return () => {
      window.removeEventListener('storage', checkPlo5);
    };
  }, []);

  const applyPlo = (link: any) => (
    `${link}?isPlo5=${isPlo5}`
  );

  useEffect(() => {
    setLanguage(getLanguage() || 'en');
  }, []);

  return (
    language
    && (
      <div id="root" className={styles.site}>
        <div className={styles.container}>
          <div className={styles.grid}>
            <Link to={routes.app.articles.tips.root} className={styles.link}>
              <img
                className={styles.image}
                src={articleOne}
                alt="1"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[0]}
              </p>
            </Link>
            <Link to={routes.app.articles.suit.root} className={styles.link}>
              <img
                className={styles.image}
                src={articleTwo}
                alt="2"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[1]}
              </p>
            </Link>
            {language === 'ru' && (
            <Link to={routes.app.articles.threeArticle.root} className={styles.link}>
              <img
                className={styles.image}
                src={articleThree}
                alt="3"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[2]}
              </p>
            </Link>
            )}
            <Link to={routes.app.articles.goodbadsuitplo5.root} className={styles.link}>
              <img
                className={styles.image}
                src={articleTwo}
                alt="4"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[3]}
              </p>
            </Link>
            <Link to={routes.app.articles.singledoublesuitplo5.root} className={styles.link}>
              <img
                className={styles.image}
                src={articleOne}
                alt="5"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[4]}
              </p>
            </Link>
            <Link to={routes.app.FAQ.root} className={styles.link}>
              <img
                className={styles.image}
                src={faq}
                alt="5"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[5]}
              </p>
            </Link>
            <Link to={applyPlo(routes.app.PreflopFAQ.root)} className={styles.link}>
              <img
                className={styles.image}
                src={faq}
                alt="5"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[6]}
              </p>
            </Link>
            <Link to={applyPlo(routes.app.trainingFaq.root)} className={styles.link}>
              <img
                className={styles.image}
                src={trainingFaq}
                alt="6"
              />
              <p className={styles.signature}>
                {mapArticles.get(language)?.[7]}
              </p>
            </Link>
          </div>
        </div>
      </div>
    )
  );
};
export default Articles;
